import React from "react";
import { BUSINESS } from "@/data/business";

export default function WhatsAppButton() {
  const msg = encodeURIComponent(
    "Hello Bhadani Electronics, I would like to enquire about your products."
  );
  return (
    <a
      href={`https://wa.me/${BUSINESS.waNumber}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-semibold text-white shadow-2xl transition-transform hover:-translate-y-0.5 hover:bg-[#1ebe58] sm:bottom-6 sm:right-6"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="h-5 w-5 fill-current"
        aria-hidden="true"
      >
        <path d="M19.11 17.28c-.29-.14-1.7-.84-1.97-.94-.26-.1-.46-.14-.65.14-.19.29-.74.94-.9 1.13-.17.19-.33.22-.62.07-.29-.14-1.21-.45-2.31-1.42-.85-.76-1.43-1.7-1.6-1.99-.17-.29-.02-.45.12-.59.13-.13.29-.34.43-.5.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.65-1.56-.89-2.13-.23-.56-.47-.48-.65-.49l-.55-.01c-.19 0-.5.07-.76.36-.26.29-1 1-1 2.43 0 1.43 1.02 2.81 1.16 3 .14.19 2 3.05 4.85 4.28.68.29 1.21.46 1.62.59.68.22 1.29.19 1.78.11.54-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.33zM16 4C9.37 4 4 9.37 4 16c0 2.12.55 4.13 1.6 5.94L4 28l6.24-1.63A11.94 11.94 0 0 0 16 28c6.63 0 12-5.37 12-12S22.63 4 16 4zm0 21.7c-1.8 0-3.53-.48-5.05-1.4l-.36-.21-3.7.97.99-3.61-.24-.37A9.68 9.68 0 0 1 6.3 16C6.3 10.66 10.66 6.3 16 6.3S25.7 10.66 25.7 16 21.34 25.7 16 25.7z" />
      </svg>
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
